/* eslint-disable */
(function ChatBar() {
  window.addEventListener("load", (event) => {
    var data = JSON.parse(document.querySelector('[data-chat-config]').innerHTML);
    var $chatLink = document.querySelectorAll('[data-chat-trigger]');
    var chatIcons = document.querySelectorAll('#icon-chat');
    var chatSpinners = document.querySelectorAll('#icon-chat-spinner');
    var enableCustomAgentCheck = true;
    var adaChatOpened = false;

    if (typeof $chatLink !== 'undefined') {
      $chatLink.forEach(function (link) {
        link.addEventListener('click', chatLinkClick);
      });

      if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.read === 'function') {
        adaChatOpened = window.Simba.Cookie.read('ada-chat-opened');
      }

      if(data.show_chat || adaChatOpened === 'true') {
        clickChat($chatLink);
      }
    }

    function clickChat($chatLink) {
      if ($chatLink.length > 0) {
        $chatLink[0].click();
        setIcon('inline');
        setSpinner('none');
      }
    }

    function chatLinkClick(evt) {
      if (typeof evt !== 'undefined') evt.preventDefault();
      if (data.settings.chat_type == 'zendesk') {
        loadZendeskChat();
        showZendeskChatWindow();
      } else if(data.settings.chat_type == 'olark') {
        loadOlarkChat();
      } else if(data.settings.chat_type == 'ada') {
        loadAdaChat();
      }
    }

    function loadAdaChat() {
      var $script = $('#__ada');
      if ($script.length == 0) {
        setIcon('none');
        setSpinner('inline');
        if (!document.getElementById('__ada')) {
          window.adaSettings = {
            toggleCallback: (isDrawerOpen) => {
              if (typeof window.Simba === 'object' && typeof window.Simba.Cookie === 'object' && typeof window.Simba.Cookie.create === 'function') {
                window.Simba.Cookie.create('ada-chat-opened', isDrawerOpen);
              }
            },
          }

          if (document.querySelector('[data-zendesk-locale]')) {
            var language = document.querySelector('[data-zendesk-locale]').getAttribute('data-zendesk-locale');
            window.adaSettings.language = language;
          }

          var script = document.createElement('script');
          script.id = '__ada';
          script.type = 'text/javascript';
          script.dataset.handle = "simba-sleep";
          script.src = 'https://static.ada.support/embed2.js';
          script.addEventListener('load', function () {
            onAdaChatLoaded();
          });
          document.body.appendChild(script);
        }
      } else {
        if (typeof window.adaEmbed !== 'undefined') {
          window.adaEmbed.toggle();
        }
      }
    }

    function onAdaChatLoaded() {
      setIcon('inline');
      setSpinner('none');

      if (!data.show_chat && adaChatOpened !== 'true' && typeof window.adaEmbed !== 'undefined') {
        window.adaEmbed.toggle();
      }
    }

    function loadOlarkChat() {
      $('#icon-chat').hide();
      $('#icon-chat-spinner').show();

      var $script = $('#olark-snippet');
      if ($script.length == 0) {
        var script = document.createElement('script');
        script.id = 'olark-snippet';
        script.type = 'text/javascript';

        var olarkLang = $('[data-olark-lang]').attr('data-olark-lang');

        var code =
          ';(function(o,l,a,r,k,y){if(o.olark)return;' +
          'r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0];' +
          'y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r);' +
          'y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)};' +
          'y.extend=function(i,j){y("extend",i,j)};' +
          'y.identify=function(i){y("identify",k.i=i)};' +
          'y.configure=function(i,j){y("configure",i,j);k.c[i]=j};' +
          'k=y._={s:[],t:[+new Date],c:{},l:a};' +
          '})(window,document,"static.olark.com/jsclient/loader.js");' +
          '/* Add configuration calls below this comment */' +
          "olark.identify('2105-488-10-6979');" +
          'olark.configure("system.localization", "' +
          olarkLang +
          '");';
        try {
          script.appendChild(document.createTextNode(code));
        } catch (e) {
          script.text = code;
        }
        document.body.appendChild(script);
      }

      $('#icon-chat').show();
      $('#icon-chat-spinner').hide();
    }

    function setIcon(state) {
      chatIcons.forEach(function (icon) {
        icon.style.display = state;
      });
    }

    function setSpinner(state) {
      chatSpinners.forEach(function (spinner) {
        spinner.style.display = state;
      });
    }

    function loadZendeskChat() {
      enableCustomAgentCheck = data.settings.enable_custom_agent_check;
      if (window.zE) {
        zE('webWidget', 'open');
      } else {
        setIcon('none');
        setSpinner('inline');
        if (!document.getElementById('ze-snippet')) {
          var script = document.createElement('script');
          script.id = 'ze-snippet';
          script.type = 'text/javascript';
          script.src = 'https://static.zdassets.com/ekr/snippet.js?key=510a8725-e49d-40f3-b7a8-aa4aca7b0daa';
          script.addEventListener('load', function () {
            onZendeskChatLoaded();
          });
          document.body.appendChild(script);
        }
      }
    }

    function onZendeskChatLoaded() {
      window.zESettings = {
        webWidget: {
          helpCenter: {
            suppress: ((data.show_chat && !data.show_support) ? true : false)
          },
          chat: {
            concierge: {
              avatarPath: data.concierge.concierge_avatar,
              name: data.concierge.concierge_name,
              title: { '*': data.concierge.concierge_title }
            },
            title: {
              '*': (data.concierge.widget_header) ? data.concierge.widget_header : ''
            }
          },
          contactForm: {
            suppress: (data.show_chat) ? true : false
          },
          contactOptions: {
            enabled: true
          },
          launcher: {
            chatLabel: {
              '*': (data.concierge.button_label) ? data.concierge.button_label : 'Chat'
            },
            label: {
              '*': (data.concierge.button_label) ? data.concierge.button_label : 'Chat'
            },
            mobile: {
              labelVisible: false
            }
          },
          zIndex: 9
        }
      };

      if (document.querySelector('[data-zendesk-locale]')) {
        var language = document.querySelector('[data-zendesk-locale]').getAttribute('data-zendesk-locale');
        zE('webWidget', 'setLocale', language);
      }

      if (!data.show_chat) {
        zE('webWidget:on', 'close', function () {
          var $iframe = document.querySelector('#launcher');
          if ($iframe !== null) {
            $iframe.style.display = 'none';
          }
        });
      }

      zE('webWidget:on', 'open', function () {
        setIcon('inline');
        setSpinner('none');
      });

      //Set defaults for chat
      zE(function () {
        $zopim(function () {
          var zl = $zopim.livechat;
          zl.setOnConnected(function () {
            var department = document.querySelector('[data-zendesk-department]').getAttribute('data-zendesk-department');
            var departmentId = document.querySelector('[data-zendesk-department-id]').getAttribute('data-zendesk-department-id');
            var department_status = zl.departments.getDepartment(department);
            if (department_status.status === 'offline') {
              zl.setStatus('offline');

              // Chat Offline Settings
              zE('webWidget', 'updateSettings', {
                webWidget: {
                  helpCenter: { suppress: false },
                  contactForm: { suppress: false }
                }
              });
            } else {
              zl.setLanguage(language); // Set language to English:
              zl.departments.filter(''); // Hide the Drop-down list option in the Pre-Chat Form to select the Department
              zl.departments.setVisitorDepartment(department); // Automatically set the Department

              if (enableCustomAgentCheck) {
                $.get('/apps/simba/chat-online', { department: departmentId }, function (online) {
                  if (!online) {
                    zl.setStatus('offline'); // Set the account status to 'offline'

                    // Chat Offline Settings
                    zE('webWidget', 'updateSettings', {
                      webWidget: {
                        helpCenter: { suppress: false },
                        contactForm: { suppress: false }
                      }
                    });
                  }
                });
              }
            }
          });
        });
      });

      if(!data.show_chat) {
        zE('webWidget', 'open');
      }
    }

    function showZendeskChatWindow() {
      if (!data.show_chat) {
        var $iframe = document.querySelector('#launcher');
        if ($iframe !== null) {
          var $trigger = $iframe.querySelector('button');
          if ($trigger !== null) {
            $triggerclick();
          }
        }
      }
    }
  });
})();
